import script from "./SideBarText.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarText.vue?vue&type=script&setup=true&lang=js"

import "./SideBarText.vue?vue&type=style&index=0&id=76c79f07&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76c79f07"]])

export default __exports__